import React, { useRef, useLayoutEffect, useState } from "react";
import { FormattedMessage } from 'react-intl';

import Constants from '../../../definitions/constants';
import FormatTooling from '../../../tooling/formatTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import { intl } from '../../../locales/localesConfig';

import Spinner from '../common/interface/spinner';
import CommandTextBox from '../common/inputs/commandTextBox';
import Select from '../common/inputs/select';
import CheckBox from "../common/inputs/checkBox";

const Table = props => {
  const targetRef = useRef();
  const [dimensions, setDimensions] = useState({ width:0, height: 0 });
  const {
    data,
    additionalData,
    loading,
    page,
    totalPages,
    totalRecords,
    fetchListChangePage,
    filtersText,
    groupsData,
    otherFilters,
    handleOnChangeOtherFilters,
    handleReloadDataWithNewFilters,
    handleShowFormPopup,
    handleDelete,
    disabledEdit,
    disabledDelete,
    filtersCollapse,
    showAuditsColumn,
    handleShowAuditPopup,
    handleOnToggleAuditsCheckbox,
    auditsCheckboxValue,
    auditDisabled
  } = props;
  
  function updateSize() {
    InterfaceTooling.delayCallAction(()=>{
      if (targetRef.current) {
        setDimensions({
          width: targetRef.current.offsetWidth,
          height: targetRef.current.offsetHeight
        });
      }
    }, null, Constants.metricDataAdmin.tableResize.delay);
  }
  
  useLayoutEffect(() => {
    updateSize();
    window.addEventListener("resize",updateSize);
    return () => 
      window.removeEventListener("resize", updateSize);
  }, [filtersCollapse]);

  var pluralName = intl.formatMessage({id: "metricDataAdmin.entityNamePlural"});
  var fixedWidth = 0;
  var styles = {}
  var columns_width = additionalData ? 100/(additionalData.headers.length + additionalData.marks_headers.length ) : 0;
  var auditColumnWidth = 300;
  if(additionalData!=null && dimensions.width>0) {
    let columnsWidthReal = (columns_width/100)*(dimensions.width-Constants.metricDataAdmin.tableResize.headerActionsSize - (showAuditsColumn ? auditColumnWidth : 0));
    fixedWidth = (columnsWidthReal < Constants.metricDataAdmin.tableResize.minSize) ? 
      (Constants.metricDataAdmin.tableResize.minSize*(additionalData.headers.length + additionalData.marks_headers.length) + Constants.metricDataAdmin.tableResize.headerActionsSize + (showAuditsColumn ? auditColumnWidth : 0)) : null;
    if(fixedWidth!=null) {
      styles["width"] = fixedWidth + "px";
    }
  }
  return (
    <div className={"table_component entity_table_component metric_data_admin_table"} ref={targetRef}>
      <div className="top_controls">
        <div className="audit_info">
          <CheckBox 
            className="metric_data_admin_changes_filter"
            id="auditsCheckbox"
            value={auditsCheckboxValue}
            onChange={handleOnToggleAuditsCheckbox}
            labelLocale={intl.formatMessage({ id: (auditDisabled ? "metricDataAdmin.showAuditsLabelDisabled" : "metricDataAdmin.showAuditsLabel") })}
            disabled={auditDisabled}
          />
        </div>
        <div className="filters_info" title={filtersText}>
          {filtersText}
        </div>
        <div className="registers_info">
          <span className="page_info page_info_total">
            {(totalRecords ? totalRecords : 0) + " " + pluralName + " - "}
          </span>
          {(page>1) && (
            <span className="pag_arrow pag_arrow_left" data-targetpage={page-1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-left"></i>
            </span>
          )}
          <span className="page_info">
            <FormattedMessage 
              id="common.entity.entityTable.pageInfo"
              values={{page: totalPages==0 ? 0 : Math.min(page,totalPages), totalPages: totalPages}}
            />
          </span>
          {(page<totalPages && totalPages>1) && (
            <span className="pag_arrow pag_arrow_right" data-targetpage={page+1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-right"></i>
            </span>
          )}
        </div>
      </div>
      {additionalData!=null ? (
        <div className="table_component_table_wrapper table_component_table_wrapper_adaptable">
          <div className="table_component_table_scroll_wrapper" style={styles}>
            <div className="table_component_table_header_wrapper table_component_table_filter_wrapper">
              <table>
                <thead>
                  <tr>
                    <th className="actions_column"></th>
                    {additionalData.headers.map( (columnHeader,i) => {
                      let systemDefectOption = i<additionalData.dimensions_count ? [{id: Constants.metricDataAdmin.systemDefect, name: intl.formatMessage({ id: "metricDataAdmin.defect"})}] : []
                      return (
                        <th 
                          key={i}
                          style={{ 
                            width: columns_width + "%"
                          }}
                          className={i<additionalData.dimensions_count ? "dimension_header" : ""}
                        >
                          {(!additionalData.info[i].system_entity_class) ? (
                            <div>
                              {(additionalData.lists[i] && additionalData.info[i].is_list) ? (
                                <Select
                                  data-path={i}
                                  data-selectlist={true}
                                  value={otherFilters[i]}
                                  formatter={FormatTooling.getMetricDatasFormatTypeFunction(additionalData.types[i])}
                                  onChange={handleOnChangeOtherFilters}
                                  labelLocale={<FormattedMessage id="metricDataAdmin.filtersLabel"/>}
                                  options={InterfaceTooling.getSelectArrayFromArrayOfObjects(systemDefectOption, "id", "name").concat(InterfaceTooling.getSelectArrayFromArray(additionalData.lists[i].values, false))}
                                />
                              ) : (
                                <CommandTextBox 
                                  data-path={i}
                                  value={otherFilters[i]}
                                  onClickCommand={handleOnChangeOtherFilters}
                                  dataType={additionalData.info[i].data_type}
                                  labelLocale={intl.formatMessage({ id: "metricDataAdmin.filtersLabel"}) + 
                                    (false ? " (" + intl.formatMessage({ id: "metricAdmin.fields.selectValues.data_type.helpers." + additionalData.info[i].data_type}) + ")" : "")
                                  }
                                />
                              )}
                            </div>
                          ) : (additionalData.info[i].system_entity_class == Constants.systemDimensionsIdentifiers.group) ? (
                            <div>
                              <Select 
                                data-path={i}
                                data-selectlist={true}
                                value={otherFilters[i]}
                                onChange={handleOnChangeOtherFilters}
                                labelLocale={<FormattedMessage id="metricDataAdmin.filtersLabel"/>}
                                options={InterfaceTooling.getSelectArrayFromArrayOfObjects(systemDefectOption.concat(groupsData), "id", "name")}
                              />
                            </div>
                          ) : null}
                        </th>
                      );
                    })}
                    {additionalData.marks_headers.map( (columnHeader,i) => {
                      return(
                        <th 
                          key={i}
                          style={{ 
                            width: columns_width + "%"
                          }}
                        >
                        </th>
                      )
                    })}
                    {showAuditsColumn && (
                      <th 
                        className="dimension_header"
                        key={-1}
                        style={{ 
                          width: auditColumnWidth + "px"
                        }}
                      >                        
                      </th>
                    )}
                  </tr>
                </thead>
              </table>
            </div>
            <div className="table_component_table_header_wrapper">
              <table>
                <thead>
                  <tr>
                    <th className="actions_column"></th>
                    {additionalData.headers.map( (columnHeader,i) => {
                      return (
                        <th 
                          key={i}
                          style={{ 
                            width: columns_width + "%"
                          }}
                          className={i<additionalData.dimensions_count ? "dimension_header" : ""}
                        >
                          <div title={columnHeader}>{columnHeader}</div>
                        </th>
                      );
                    })}
                    {additionalData.marks_headers.map( (columnHeader,i) => {
                      return(
                        <th 
                          key={additionalData.headers.length + i}
                          style={{ 
                            width: columns_width + "%"
                          }}
                          className={"mark_header"}
                          >
                          <div title={columnHeader}>{columnHeader}</div>
                        </th>
                      )
                    })}
                    {showAuditsColumn && (
                      <th
                        className="dimension_header audit_header"
                        key={-1}
                        style={{ 
                          width: auditColumnWidth + "px"
                        }}
                      >
                        <div title={intl.formatMessage({ id: "metricDataAdmin.auditColumnHeaderLabel" })}>
                          <FormattedMessage id="metricDataAdmin.auditColumnHeaderLabel"/>
                        </div>
                      </th>
                    )}
                  </tr>
                </thead>
              </table>
            </div>
            <div className="table_component_table_body_wrapper">
              <table>
                <thead>
                  <tr>
                    <th className="actions_column"></th>
                    {additionalData.headers.map((columnHeader,i) => {
                      return (<th key={i} style={{width: columns_width + "%" }}>{""}</th>);
                    })}
                    {additionalData.marks_headers.map((columnHeader,i) => {
                      return (<th key={additionalData.headers.lenght + i} style={{width: columns_width + "%" }}>{""}</th>);
                    })}
                    {showAuditsColumn && (
                      <th key={-1} style={{width: auditColumnWidth + "px" }}>{""}</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                {data && data.map((record,i) => {
                  return (
                    <tr key={i}>
                      <td className="actions_column">
                        {disabledEdit ? null :
                          <i 
                            data-recorddata={JSON.stringify(record)}
                            className="fas fa-edit"
                            onClick={handleShowFormPopup}
                            title={intl.formatMessage({ id: "common.entityTableActions.edit"})}
                          />
                        }
                        {disabledDelete ? null :
                          <i 
                            data-recorddata={JSON.stringify(record)}
                            className="fas delete-action fa-trash"
                            onClick={handleDelete}
                            title={intl.formatMessage({ id: "common.entityTableActions.delete"})}
                          />
                        }
                      </td>
                      {record.values.map((value,i) => {
                        let formated_value = FormatTooling.metricDatasFormatTypes(value,additionalData.types[i]);
                        return (
                          <td key={i} className={"align_left" + (i<additionalData.dimensions_count ? " dimension_cell" : "")}>
                            <div title={formated_value}>{formated_value}</div>
                          </td>
                        );  
                      })}
                      {record.marks_values.map((value,i) => {
                        let formated_value = FormatTooling.metricDatasFormatTypes(value,additionalData.marks_types[i]);
                        return (
                          <td key={i} className={"align_left"}>
                            <div title={formated_value}>{formated_value}</div>
                          </td>
                        );  
                      })}
                      {showAuditsColumn && (
                        <td key={-1} className="audit_column">
                          <div title={record.update_info}>
                            {record.update_job_key && (
                              <i 
                                data-recorddata={JSON.stringify(record)}
                                className="fas fa-info-circle"
                                data-entitydata={JSON.stringify({notification_id: record.update_job_key})}
                                onClick={handleShowAuditPopup}
                                title={intl.formatMessage({ id: "common.entityTableActions.auditJobInfo"})}
                              />
                            )}
                            {record.update_info}
                          </div>
                        </td>
                      )}
                    </tr>                      
                  );    
                })}
                </tbody>
              </table>
              {loading && (<div className="table_eof">
                <Spinner/>
                <span>
                  <FormattedMessage id="metricDataAdmin.loadingRegisters"/>
                </span>
              </div>)}
            </div>
          </div>
          {(!loading && page >= totalPages) && (<div className="table_eof">
            <i className="fas fa-check-circle"/>
            <span>
              <FormattedMessage id="metricDataAdmin.noMoreRegisters"/>
            </span>
          </div>)}
        </div>
      ) : null}
    </div>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/metricDataAdmin/table.jsx